function formatUrlToRequest(url: string, service_type: string): string {
    const urlParsed = new URL(url) // NEEDED : https://developer.mozilla.org/en-US/docs/Web/API/URLSearchParams#no_url_parsing
    const searchParams = new URLSearchParams(urlParsed.search)

    // url to lowercase ?
    const hasRequest = searchParams.has('REQUEST') || searchParams.has('request')
    const hasService = searchParams.has('SERVICE') || searchParams.has('service')
    const hasVersion = searchParams.has('VERSION') || searchParams.has('version')

    if (!hasRequest)
        urlParsed.searchParams.append('REQUEST', 'GetCapabilities')
    if (!hasService)
        urlParsed.searchParams.append('SERVICE', service_type === 'WMS' ? 'WMS' : 'WMTS')
    if (!hasVersion)
        urlParsed.searchParams.append('VERSION', service_type === 'WMS' ? '1.3.0' : '1.0.0')

    return urlParsed.toString()
}

function clearParamsFromUrl(url: string): string {
    const urlParsed = new URL(url);
    ['REQUEST', 'request', 'VERSION', 'version', 'SERVICE', 'service'].forEach((param: string) => urlParsed.searchParams.delete(param))

    return urlParsed.toString()
}

export { formatUrlToRequest, clearParamsFromUrl }
